"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMaxWidth = exports.getParagraphSize = exports.getFontStyle = void 0;
var _styledComponents = require("styled-components");

/**
 * @param @required typeSettings
 * @param @required breakpoint
 * @param min optional override minimum font size
 * @param max optional override maximum font size
 *
 * @returns css`` all css for that specific type component
 */
var getFontStyle = function getFontStyle() {
  var typeSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    color: 'inherit',
    colorInverse: 'inherit',
    fontSizeLg: null,
    fontSizeSm: null,
    fontWeight: null,
    lineHeight: null,
    marginBottom: null,
    marginBottomLg: null,
    marginTop: null,
    marginTopLg: null,
    textTransform: 'normal'
  };
  var breakpoint = arguments.length > 1 ? arguments[1] : undefined;
  var minOverride = arguments.length > 2 ? arguments[2] : undefined;
  var maxOverride = arguments.length > 3 ? arguments[3] : undefined;
  return (0, _styledComponents.css)(["", ";"], function (props) {
    var fontWeight = props.theme.fontWeight[props.fontWeight] || typeSettings.fontWeight;
    return (0, _styledComponents.css)(["color:", ";font-size:", ";font-weight:", ";line-height:", ";margin:", "  0  ", "  0;text-transform:", ";&.color-brand-primary{color:", ";}", " ", " @media (min-width:", "){font-size:", ";margin:", "  0  ", "  0;}"], props.inverse ? typeSettings.colorInverse : typeSettings.color, minOverride || typeSettings.fontSizeSm, fontWeight, typeSettings.lineHeight, props.disableMargin ? 0 : typeSettings.marginTop, props.disableMargin ? 0 : typeSettings.marginBottom, typeSettings.textTransform, props.theme.colors.brandPrimary, props.color === 'brandPrimary' && (0, _styledComponents.css)(["color:", ";"], props.theme.colors.brandPrimary), props.theme.colors[props.color] && (0, _styledComponents.css)(["color:", ";"], props.theme.colors[props.color]), breakpoint, maxOverride || typeSettings.fontSizeLg, props.disableMargin ? 0 : typeSettings.marginTopLg, props.disableMargin ? 0 : typeSettings.marginBottomLg);
  });
};
exports.getFontStyle = getFontStyle;
var getParagraphSize = function getParagraphSize(elKey, size) {
  switch (size) {
    case 'xs':
      return {
        min: elKey.fontSizeXs || elKey.fontSizeSm,
        max: elKey.fontSizeXs || elKey.fontSizeMd
      };
    case 'sm':
      return {
        min: elKey.fontSizeSm,
        max: elKey.fontSizeMd
      };
    case 'md':
      return {
        min: elKey.fontSizeMd,
        max: elKey.fontSizeLg
      };
    case 'lg':
      return {
        min: elKey.fontSizeLg,
        max: elKey.fontSizeXl
      };
    default:
      return {
        min: elKey.fontSizeMd,
        max: elKey.fontSizeLg
      };
  }
};
exports.getParagraphSize = getParagraphSize;
var calculateMaxWidth = function calculateMaxWidth(maxWidth, padding) {
  return parseInt(maxWidth) + 2 * parseInt(padding);
};
exports.calculateMaxWidth = calculateMaxWidth;